import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Mobile Services - staggered fade in with slide from left
 */
export const animateMobileServices = (ref, isMobile, isLoading, safeServicesData) => {
  if (ref.current && isMobile && !isLoading && safeServicesData.length > 0) {
    // Set initial state immediately to prevent flash
    const cards = ref.current.querySelectorAll('[class*="mobileMainCardWrapper"]');
    if (cards.length > 0) {
      gsap.set(cards, { opacity: 0, x: -100 });
    }
    
    const timer = setTimeout(() => {
      if (cards.length > 0) {
        gsap.to(cards, {
          opacity: 1,
          x: 0,
          duration: 0.8,
          stagger: 0.1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: ref.current,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        });
        ScrollTrigger.refresh();
      }
    }, 200);
    
    return () => clearTimeout(timer);
  }
};

